import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/cp-img01.jpg'
import gImg2 from '../../images/gallery/cp-img02.jpg'
import gImg3 from '../../images/gallery/cp-img03.jpg'
import gImg4 from '../../images/gallery/cp-img04.jpg'
import gImg5 from '../../images/gallery/cp-img05.jpg'
import gImg6 from '../../images/gallery/cp-img06.jpg'

const PrivacyPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="compliance icon" />Enterprise Data Governance</span>
                                        <h2 className="title">Bogin Tech Privacy Framework for <br /> Enterprise Technology Services <br /> & Platforms</h2>
                                        <span className="page-update_time">Effective: February 15, 2025</span>
                                    </div>
                                </div>
                                <div className="col-lg-4 mt-30">
                                    <div className="cp-img-slide">
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-120 pb-75">
                            <div className="row">
                                <div className="col-lg-11">
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Data Governance Framework</h2>
                                        <p>As Data Controller, Bogin Tech collects enterprise operational metadata including cloud usage patterns, API transaction logs, and AI model performance metrics. Data collection occurs through our service mesh architecture and is essential for SLA enforcement, security monitoring, and platform optimization.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Enterprise Client Obligations</h2>
                                        <p>Client administrators must ensure end-user consent management aligns with GDPR/CCPA requirements when integrating our services. Bogin Tech disclaims liability for unauthorized data processing initiated through client-configured workflows.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Security & Processing Standards</h2>
                                        <p>Data processing occurs in SOC 2 Type II certified facilities with AES-256 encryption enforcement. Access is restricted through Zero Trust principles with granular RBAC controls. Third-party processors undergo annual security audits and maintain ISO 27001 certification.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Data Lifecycle Management</h2>
                                        <p>Production data is retained for 36 months post-contract termination with 90-day cold storage archiving. AI training datasets undergo annual anonymization sweeps. Data destruction follows NIST 800-88 guidelines with certificate issuance.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Cross-Border Transfers</h2>
                                        <p>EU-US data transfers utilize latest adequacy decisions with supplementary measures including confidential computing and contractual clauses. China-bound data resides in Shanghai Azure regions with MoH approval.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Enterprise User Rights</h2>
                                        <ul className="privacy-details">
                                            <li>Audit data processing activities through admin portals</li>
                                            <li>Request dataset portability in Apache Parquet format</li>
                                            <li>Restrict processing during compliance investigations</li>
                                            <li>Obtain processing impact assessments</li>
                                            <li>Designate EU/UK representatives</li>
                                            <li>Access real-time data processing dashboards</li>
                                        </ul>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Monitoring & Compliance</h2>
                                        <p>Platform telemetry collection is essential for SOC 2 controls. Opt-outs available through enterprise contract amendments with corresponding SLA adjustments.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Policy Governance</h2>
                                        <p>Changes trigger 30-day enterprise notifications via admin consoles. Continued platform access constitutes acceptance after effective dates.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Incident Response</h2>
                                        <p>Breach notifications within 72 hours of confirmation. Enterprise clients must maintain designated security contacts in our GRC portal.</p>
                                    </div>
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Enterprise Contact Protocol</h2>
                                        <p>Data Protection Officer access via <Link onClick={ClickHandler} to="/contact" className="details-link">GRC portal</Link> or <a href="mailto:dpo@bogin.tech">dpo@bogin.tech</a>. Emergency contacts available through 24/7 SOC hotline.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CtaSection cClass={'bg'}/>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacyPage;
